import React, { Fragment, useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Footer from '../../component/Other/Footer';
import Navbar from '../../component/Other/Navbar';
import { supabase } from '../../lib/supabaseClient';

const Recuperacion = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isRecoveryMode, setIsRecoveryMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    const hashParams = new URLSearchParams(window.location.hash.substring(1));
    const type = hashParams.get('type');
    if (type === 'recovery') {
      setIsRecoveryMode(true);
    }
  }, []);

  const handleSetNewPassword = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      setMessage({ type: 'error', text: 'La contraseña debe tener al menos 8 caracteres.' });
      return;
    }
    if (password !== confirmPassword) {
      setMessage({ type: 'error', text: 'Las contraseñas no coinciden.' });
      return;
    }
    if (!supabase) {
      setMessage({ type: 'error', text: 'Error de configuración. Contacta al soporte.' });
      return;
    }
    setLoading(true);
    setMessage({ type: '', text: '' });
    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      setMessage({ type: 'success', text: 'Contraseña actualizada. Ya puedes iniciar sesión con tu nueva contraseña en la app ListoPago.' });
      setPassword('');
      setConfirmPassword('');
      setIsRecoveryMode(false);
      window.history.replaceState(null, '', '/recuperacion');
    } catch (err) {
      setMessage({ type: 'error', text: err.message || 'Ocurrió un error. El enlace puede haber expirado.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <div className="overflow-hidden font-poppins">
        <div className="bg__blue-2">
          <Navbar />
          <section className="position-relative py-5">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-md-8 col-lg-6">
                  <div className="rounded__12 p-4 p-md-5 shadow" style={{ backgroundColor: '#fff' }}>
                    <div className="text-center mb-4">
                      <h1 className="semi-bold font__size--28 text__24-1024 mb-2" style={{ color: '#626475' }}>
                        {isRecoveryMode ? 'Nueva contraseña' : 'Enlace inválido'}
                      </h1>
                      <p className="medium font__size--16 text__16-1024 lh-2 mb-0" style={{ color: '#626475' }}>
                        {isRecoveryMode
                          ? 'Ingresa tu nueva contraseña (mínimo 8 caracteres).'
                          : 'Este enlace no es válido o ha expirado. Solicita uno nuevo desde la app ListoPago.'}
                      </p>
                    </div>

                    {message.text && (
                      <div
                        className={`rounded__12 p-3 mb-4 ${message.type === 'success' ? 'alert-success' : 'alert-danger'}`}
                        style={{
                          backgroundColor: message.type === 'success' ? '#d4edda' : '#f8d7da',
                          color: message.type === 'success' ? '#155724' : '#721c24',
                          border: 'none',
                        }}
                      >
                        {message.text}
                      </div>
                    )}

                    {isRecoveryMode && (
                      <form onSubmit={handleSetNewPassword}>
                        <div className="form-group">
                          <label className="semi-bold font__size--14 text__14-1024 mb-2" style={{ color: '#333' }}>
                            Nueva contraseña
                          </label>
                          <div className="d-flex align-items-center wrapper__field-wrap" style={{ border: '1px solid #E0E0E0', borderRadius: '12px' }}>
                            <input
                              type={showPassword ? 'text' : 'password'}
                              className="form-control medium font__size--16 text__16-1024 border-0 rounded__12 flex-grow-1"
                              placeholder="Mínimo 8 caracteres"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              style={{ border: 'none' }}
                            />
                            <span
                              className="pointer ml-2"
                              onClick={() => setShowPassword(!showPassword)}
                              style={{ cursor: 'pointer', fontSize: '14px', color: '#626475', flexShrink: 0 }}
                            >
                              {showPassword ? 'Ocultar' : 'Ver'}
                            </span>
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="semi-bold font__size--14 text__14-1024 mb-2" style={{ color: '#333' }}>
                            Confirmar contraseña
                          </label>
                          <div className="d-flex align-items-center wrapper__field-wrap" style={{ border: '1px solid #E0E0E0', borderRadius: '12px' }}>
                            <input
                              type={showConfirmPassword ? 'text' : 'password'}
                              className="form-control medium font__size--16 text__16-1024 border-0 rounded__12 flex-grow-1"
                              placeholder="Repite la contraseña"
                              value={confirmPassword}
                              onChange={(e) => setConfirmPassword(e.target.value)}
                              style={{ border: 'none' }}
                            />
                            <span
                              className="pointer ml-2"
                              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                              style={{ cursor: 'pointer', fontSize: '14px', color: '#626475', flexShrink: 0 }}
                            >
                              {showConfirmPassword ? 'Ocultar' : 'Ver'}
                            </span>
                          </div>
                        </div>
                        <button
                          type="submit"
                          className="btn btn__purple color__white semi-bold font__size--16 rounded__12 px-4 py-3 w-100 shadow"
                          disabled={loading}
                        >
                          {loading ? 'Guardando...' : 'Actualizar contraseña'}
                        </button>
                      </form>
                    )}

                    <div className="text-center mt-4">
                      <NavLink to="/" className="medium font__size--14 text__14-1024 color__purple">
                        ← Volver al inicio
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <img src="./../images/Subtract.png" className="w-100 img-cover" alt="" />
        <Footer />
      </div>
    </Fragment>
  );
};

export default Recuperacion;
